import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DropdownOption } from 'globals/store/programs.data';
import { CURRENCY_OPTIONS } from '../../store/reselectors/currencies.data';
import { JoiAccount } from 'globals/store/accounts.data';
import { Wrapper } from '../../components/wrapper.component';
import { DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component';
import { CommonModule } from '@angular/common';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { MatRadioModule } from '@angular/material/radio';
import { ToggleTabComponent } from 'src/app/components/buttons/toggle-tab.component';
import { DropdownComponent } from 'src/app/components/misc/dropdown.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'share-revenue-settings',
    templateUrl: './share-revenue-settings.html',
    styleUrls: ['./share-revenue-settings.scss'],
    standalone: true,
    imports: [DialogWrapperComponent, FormsModule, FindByIdPipe, CommonModule, TipTextComponent, MatRadioModule, ToggleTabComponent, DropdownComponent, JoiInputComponent ],
})
export class ShareRevenueSettingsComponent extends Wrapper<ShareRevenueSettingsComponent> implements OnInit {

  currencyOptions = CURRENCY_OPTIONS
  maxHeight: string
  taxOptions: DropdownOption[] = [
    { id: 'inclusive', title: 'Tax inclusive' },
    { id: 'exclusive', title: 'Tax exclusive' },
  ]
  selectedTaxOption: DropdownOption
  account: Partial<JoiAccount>

  constructor(
    public dialogRef:MatDialogRef<ShareRevenueSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ShareRevenueSettingsDialogData,
  ) {
    super()
    this.subCallback(this.store.select('accounts', 'account'), account => {
      if (!account) return
      this.account = account
    })
  }

  ngOnInit() {
    this.data.currencyId = this.data.budgetCurrency
    let { x, y } = this.data
    // console.log({ x, y })
    if (y && document.body.clientHeight - y < 400) {
      y = Math.max(1, document.body.clientHeight - 400);
    }
    console.log({ y, clientHeight: document.body.clientHeight })
    this.maxHeight = `${document.body.clientHeight - y - 50}px`
    // console.log({ x, y })
    if (x && y) this.dialogRef.updatePosition({ top: y + 'px', left: x + 'px' });
    console.log({ y, clientHeight: document.body.clientHeight })
  }


  updateCurrency(currencyId: string) {
    this.data.currencyId = currencyId
  }

  updateConversionRate() {
    let amount: number
    try {
      amount = +this.data.conversionRate
      if (isNaN(amount)) amount = 1
    } catch {
      amount = 1
    }
    this.data.conversionRate = amount
  }
  
}

export interface ShareRevenueSettingsDialogData {
  x: number
  y: number
  version: number
  currencyId?: string
  budgetCurrency: string
  conversionRate: number
  hidePaymentSchedule?: boolean
  hideFileLinks?: boolean
  showInAnotherCurrency?: boolean
  detailedView?: boolean
  account: Partial<JoiAccount>
  headerDesktopUrl?: string
  headerMobileUrl?: string
  footerText?: string
}




